import $ from 'jquery';

$(document).ready(function() {
    if(window.ccBidrate == undefined)
    {
        var ccBidrate = {'EUR\/USD':'1.14559','GBP\/USD':'1.30851','EUR\/GBP':'0.87538','EUR\/AUD':'1.58028','EUR\/CAD':'1.49956','EUR\/NZD':'1.66110','USD\/CAD':'1.30903','GBP\/CAD':'1.71287','AUD\/USD':'0.72484','AUD\/CAD':'0.94882','NZD\/USD':'0.68954','AUD\/NZD':'1.05105'};

    }else{
        var ccBidrate = window.ccBidrate;
    }
    $('.dr-one').click(function() {
        $('.fordr-one').toggle();
    });
    $('.dr-two').click(function() {
        $('.fordr-two').toggle();
    });
    var amount = $('.frm_amt').val();
    amount = parseInt(amount.replace(/,/g, ''), 10);

    if( (amount !== ' ') && ( amount >= 0 ) ) {
        $('.frm_amt').val(Number(amount).toLocaleString('en'));
        var toCurrency = $('.to_amt').attr('priceto');
        var fromCurrency = $('.frm_amt').attr('pricefrm');

        common_resp_from(amount,toCurrency,fromCurrency);
    }
    function get_currency_rate(currency_pair)
    {
        var nowRate ;

        switch(currency_pair)
        {
            case 'CAD/CAD':
                nowRate=1;
                break;

            case 'USD/USD':
                nowRate=1;
                break;
            case 'AUD/AUD':
                nowRate=1;
                break;
            case 'EUR/EUR':
                nowRate=1;
                break;
            case 'NZD/NZD':
                nowRate=1;
                break;
            case 'GBP/GBP':
                nowRate=1;
                break;

            case 'CAD/USD':
                nowRate=(1/ccBidrate['USD/CAD']);
                break;
            case 'CAD/EUR':
                nowRate=(1/ccBidrate['EUR/CAD']);
                break;
            case 'CAD/GBP':
                nowRate=(1/ccBidrate['GBP/CAD']);
                break;
            case 'CAD/AUD':
                nowRate=(1/ccBidrate['AUD/CAD']);
                break;
            case 'USD/EUR':
                nowRate=(1/ccBidrate['EUR/USD']);
                break;
            case 'USD/GBP':
                nowRate=(1/ccBidrate['GBP/USD']);
                break;
            case 'GBP/EUR':
                nowRate=(1/ccBidrate['EUR/GBP']);
                break;
            case 'AUD/EUR':
                nowRate=(1/ccBidrate['EUR/AUD']);
                break;
            case 'USD/AUD':
                nowRate=(1/ccBidrate['AUD/USD']);
                break;
            case 'NZD/EUR':
                nowRate=(1/ccBidrate['EUR/NZD']);
                break;
            case 'USD/NZD':
                nowRate=(1/ccBidrate['NZD/USD']);
                break;
            case 'NZD/AUD':
                nowRate=(1/ccBidrate['AUD/NZD']);
                break;
            case 'CAD/NZD':

                usdRate = ccBidrate['USD/CAD'];
                usdRate2 = ccBidrate['NZD/USD'];
                usdRate2 = (1/usdRate2);
                nowRate = (usdRate2/usdRate);


                break;
            case 'NZD/CAD':
                usdRate = ccBidrate['USD/CAD'];
                usdRate2 = ccBidrate['NZD/USD'];
                usdRate2 = (1/usdRate2);
                nowRate = (usdRate/usdRate2);
                break;
            case 'GBP/NZD':
                usdRate = ccBidrate['EUR/GBP'];
                usdRate2 = ccBidrate['EUR/NZD'];
                nowRate = (usdRate2/usdRate);
                break;
            case 'NZD/GBP':
                usdRate = ccBidrate['EUR/GBP'];
                usdRate2 = ccBidrate['EUR/NZD'];
                nowRate = (usdRate/usdRate2);
                break;
            case 'AUD/GBP':
                usdRate = ccBidrate['EUR/AUD'];
                usdRate2 = ccBidrate['EUR/GBP'];
                nowRate = (usdRate2/usdRate);
                break;
            case 'GBP/AUD':
                usdRate = ccBidrate['EUR/AUD'];
                usdRate2 = ccBidrate['EUR/GBP'];
                nowRate = (usdRate/usdRate2);
                break;
            default:
                nowRate = ccBidrate[currency_pair];

        }
        return nowRate;
    }
    $(function() {
        $(document).on('keyup keypress','.to_amt', function(event) {
            var unicode=event.charCode? event.charCode : event.keyCode;

            if( (unicode===8) || (unicode===13) || (unicode>=48 && unicode<=57) || (unicode>=96 && unicode<=105) ) {
                var key = event.key? event.key : 0;

                if(key==='a' || key==='b' || key==='c' || key==='d' || key==='e' || key==='f' || key==='g' || key==='h' || key==='i' ) {
                    return false;
                }else{
                    var toAmount = $('.to_amt').val();
                    toAmount = parseInt(toAmount.replace(/,/g, ''), 10);
                    if( (toAmount !==' ') && ( toAmount >= 0 ) ) {

                        $('.to_amt').val(Number(toAmount).toLocaleString('en'));
                        var toCurrency = $('.to_amt').attr('priceto');
                        var fromCurrency = $('.frm_amt').attr('pricefrm');

                        common_resp(toAmount,toCurrency,fromCurrency);
                    }
                }
            }else{
                return false;
            }

        });

        $(document).on('keyup keypress','.frm_amt', function(event) {
            var unicode=event.charCode? event.charCode : event.keyCode;

            if( (unicode===8) || (unicode===13) || (unicode>=48 && unicode<=57) || (unicode>=96 && unicode<=105) ) {
                var key = event.key? event.key : 0;

                if(key==='a' || key==='b' || key==='c' || key==='d' || key==='e' || key==='f' || key==='g' || key==='h' || key==='i' ) {
                    return false;
                }else{
                    var amount = $('.frm_amt').val();
                    amount = parseInt(amount.replace(/,/g, ''), 10);

                    if( (amount !==' ') && ( amount >= 0 ) ) {
                        $('.frm_amt').val(Number(amount).toLocaleString('en'));
                        var toCurrency = $('.to_amt').attr('priceto');
                        var fromCurrency = $('.frm_amt').attr('pricefrm');

                        common_resp_from(amount,toCurrency,fromCurrency);
                    }
                }
            }else{
                return false;
            }

        });

    });

    var amount = $('.to_amt').val();
    var toCurrency = $('.to_amt').attr('priceto');
    var fromCurrency = $('.frm_amt').attr('pricefrm');
    if( (amount !== '') && (amount>0) ) {
        common_resp(amount,toCurrency,fromCurrency);
    }

    function common_resp(amount,toCurrency,fromCurrency) {
        var amount = amount;
        var toCurrency = toCurrency;
        var fromCurrency = fromCurrency;
        var bnkrt = $('.bnkrt').val();
        if(bnkrt==='') {
            bnkrt=0;
        }
        if(amount>0) {
            var data = {
                'action'		: 'get_currency_change_details',
                'toCurrency' 	: toCurrency,
                'fromCurrency'	: fromCurrency,
                'amount'		: amount
            };


            var a = toCurrency + '/' + fromCurrency;

            var new_rate = get_currency_rate(a);
            var final_rate = amount*new_rate;
            var comma = Number(parseFloat(final_rate).toFixed(2)).toLocaleString('en',{ minimumFractionDigits: 2 });
            $('.frm_amt').val(comma);
            $('.interbank').text('Current interbank rate: '+parseFloat(new_rate).toFixed(4));
            var bnk = ((parseFloat(amount)*bnkrt)/100);
            bnk = bnk.toFixed(2);
            $('.bank-save span').html('CAD $'+bnk);

            /*	$.post( 'https://www.knightsbridgefx.com/wp-admin/admin-ajax.php', data, function( response ){
                      var json = $.parseJSON(response);
                      if( json.code == 200 ){
                          var comma = Number(parseFloat(json.data).toFixed(2)).toLocaleString('en',{ minimumFractionDigits: 2 });
                          $('.frm_amt').val(comma);
                          $('.interbank').text("Current interbank rate: "+parseFloat(json.rate).toFixed(4));
                          var bnk = ((parseFloat(amount)*bnkrt)/100);
                          $('.bank-save').html("Exchanging with KnightsbridgeFX vs. your bank could save you CAD$ "+bnk);
                      }
                  }); */
        }
    }

    //=================================== Reverse Case Common function =========================================//
    function common_resp_from(amount,toCurrency,fromCurrency) {
        var amount = amount;
        var toCurrency = toCurrency;
        var fromCurrency = fromCurrency;
        var bnkrt = $('.bnkrt').val();
        if(bnkrt==='') {
            bnkrt=0;
        }
        if(amount>0) {
            var data = {
                'action'		: 'reverse_get_currency_change_details',
                'toCurrency' 	: toCurrency,
                'fromCurrency'	: fromCurrency,
                'amount'		: amount
            };

            var a = fromCurrency + '/' + toCurrency;

            var new_rate = get_currency_rate(a);

            var final_rate = amount*new_rate;
            var comma = Number(parseFloat(final_rate).toFixed(2)).toLocaleString('en',{ minimumFractionDigits: 2 });

            $('.to_amt').val(comma);
            $('.interbank').text('Current interbank rate: '+parseFloat(new_rate).toFixed(4));
            var bnk = ((parseFloat(amount)*bnkrt)/100);
            bnk = bnk.toFixed(2);
            $('.bank-save span').html('CAD $'+bnk);
            /*	$.post( 'https://www.knightsbridgefx.com/wp-admin/admin-ajax.php', data, function( response ){
                      var json = $.parseJSON(response);
                      if( json.code == 200 ){
                          var comma = Number(parseFloat(json.data).toFixed(2)).toLocaleString('en',{ minimumFractionDigits: 2 });
                          $('.to_amt').val(comma);
                          $('.interbank').text("Current interbank rate: "+parseFloat(json.rate).toFixed(4));
                          var bnk = ((parseFloat(amount)*bnkrt)/100);
                          $('.bank-save').html("Exchanging with KnightsbridgeFX vs. your bank could save you CAD$ "+bnk);
                      }
                  }); */

        }
    }
    //========================================== End =====================================================//

    $(document).on('click','.curr-to',function(e) {
        e.preventDefault();
        var flag = $(this).attr('flag');
        var curren = $(this).attr('curren');
        var url = $('.flag-img').attr('src');
        var lastPart = url.split('/');
        var lastPart = url.replace(lastPart[lastPart.length-1], flag);

        $('.tocurr').text(curren); $('.abcd').val(curren);
        $('.flag-img').attr('src',lastPart);
        $('.to_amt').attr('priceto',curren);

        var amount = $('.to_amt').val();
        amount = parseInt(amount.replace(/,/g, ''), 10);
        var toCurrency = curren;
        var fromCurrency = $('.frm_amt').attr('pricefrm');
        if( (amount !== '') && (amount>0) ) {
            common_resp(amount,toCurrency,fromCurrency);
        }

    });

    $(document).on('click','.curr-from',function(e) {
        e.preventDefault();
        var flag = $(this).attr('flag');
        var curren = $(this).attr('curren');
        var url = $('.flag-frm-img').attr('src');
        var lastPart = url.split('/');
        var lastPart = url.replace(lastPart[lastPart.length-1], flag);

        $('.frmcurr').text(curren); $('.wxyz').val(curren);
        $('.flag-frm-img').attr('src',lastPart);
        $('.frm_amt').attr('pricefrm',curren);

        var amount = $('.to_amt').val();
        amount = parseInt(amount.replace(/,/g, ''), 10);
        var toCurrency = $('.to_amt').attr('priceto');
        var fromCurrency = curren;

        if( (amount !== '') && (amount>0) ) {
            common_resp(amount,toCurrency,fromCurrency);
        }

    });

    $(document).on('blur','.to_amt',function(e) {
        var amount = $(this).val();
        amount = parseInt(amount.replace(/,/g, ''), 10);
        var toCurrency = $(this).attr('priceto');
        var fromCurrency = $('.frm_amt').attr('pricefrm');
        if( (amount !== '') && (amount>0) ) {
            common_resp(amount,toCurrency,fromCurrency);
        }

    });

    $(document).on('blur','.frm_amt',function(e) {
        var amount = $(this).val();
        amount = parseInt(amount.replace(/,/g, ''), 10);
        var toCurrency = $('.to_amt').attr('priceto');
        var fromCurrency = $('.frm_amt').attr('pricefrm');
        if( (amount !== '') && (amount>0) ) {
            common_resp_from(amount,toCurrency,fromCurrency);
        }

    });

    function numbersonly(e) {
        var unicode=e.charCode? e.charCode : e.keyCode;

        if( (unicode===8) || (unicode===13) || (unicode>=48 && unicode<=57) || (unicode>=96 && unicode<=105) ) {

            var toAmount = $('.to_amt').val();
            if( (toAmount !=='') && (toAmount >0) ) {
                var key = e.key? e.key : 0;
                toAmount = parseInt(toAmount.replace(/,/g, ''), 10);
                $('.to_amt').val(Number(toAmount).toLocaleString('en'));
                var toCurrency = $('.to_amt').attr('priceto');
                var fromCurrency = $('.frm_amt').attr('pricefrm');

                common_resp(toAmount,toCurrency,fromCurrency);
            }
        }else{
            $('.to_amt').val(0);
            return false;
        }
    }

    function revnumbersonly(e) {
        var unicode=e.charCode? e.charCode : e.keyCode;

        if( (unicode===8) || (unicode===13) || (unicode>=48 && unicode<=57) || (unicode>=96 && unicode<=105) ) {
            var amount = $('.frm_amt').val();
            if((amount !=='') && (amount >0) ) {
                var key = e.key? e.key : 0;
                amount = parseInt(amount.replace(/,/g, ''), 10);
                $('.frm_amt').val(Number(amount).toLocaleString('en'));
                var toCurrency = $('.to_amt').attr('priceto');
                var fromCurrency = $('.frm_amt').attr('pricefrm');

                common_resp_from(amount,toCurrency,fromCurrency);
            }
        }else{
            $('.frm_amt').val(0);
            return false;
        }

    }
});